
import { config } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '標題',
    model: 'title',
    placeholder: '標題',
    required: true,
    validator: function () {
      this.validation();
      let title = this.model.title;
      if(title.length>20){
        this.inputError = true;
        this.errorMessage = "標題限制20字內";  
      }    
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '品牌名稱  ',
    model: 'brand_name',
    placeholder: '品牌名稱',
    required: true,
    validator: function () {
      this.validation();     
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '外站連結',
    model: 'web_url',
    placeholder: '外站連結',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  // {
  //   type: "x-QuillEditor",
  //   label: "內容",
  //   model: "content",
  //   validator: function () {
  //     this.validation();
  //   },
  // },
  {
    type: "bsx-upload",
    label: "封面圖片",      
    model: "logo",
    help: "LOGO：90px * 90px",
    kind: "button",
    required: true,
    browse: true,
    preview: true,
    accept: ".jpg,.png",
    folder: "partner",
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-upload",
    label: "內頁文宣圖",      
    model: "photo",
    help: "內頁文宣：768px * 1204px",
    kind: "button",
    required: true,
    browse: true,
    preview: true,
    accept: ".jpg,.png",
    folder: "partner",
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "number",
    label: "排序",
    hint: "權重數字越大，排序越前；若數字相同，則 ID 越大，排序越前",
    model: "weight",
    placeholder: "排序權重",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'status',
    required: true, 
  },
];

export default fields;
